import React, {useEffect, useRef, useState} from 'react'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import QrCodeScanner from '../../../components/QrCodeScanner/QrCodeScanner'
import {isporuciPaketeQRApi} from '../../../api/paketiPanela'
import {KTIcon} from '../../../../_websoft/helpers'

type Feedback = {
  type: 'success' | 'danger'
  message: string
}

const IsporuciPaket: React.FC = () => {
  const initialValues = {
    paket: '',
  }
  const [initialData] = useState(initialValues)
  const [loading, setLoading] = useState(false)
  const [feedback, setFeedback] = useState<Feedback | null>(null)
  const paketInputRef = useRef<HTMLInputElement>(null)

  const validationSchema = Yup.object({
    paket: Yup.string().required('Required'),
  })

  useEffect(() => {
    if (!loading) {
      paketInputRef.current?.focus()
    }
  }, [loading])

  const handleQrScan = (data: string) => {
    setFeedback(null)
    formik.setFieldValue('paket', data)
    setTimeout(() => {
      paketInputRef.current?.focus()
      paketInputRef.current?.select()
    }, 0)
  }

  const handleFormKeyDown = (event: React.KeyboardEvent<HTMLFormElement>) => {
    if (event.key === 'Enter' && event.target instanceof HTMLInputElement) {
      event.preventDefault()
      event.stopPropagation()
      paketInputRef.current?.blur()
    }
  }

  const formik = useFormik({
    initialValues: initialData,
    validationSchema: validationSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setFeedback(null)
      setLoading(true)
      try {
        let response
        console.log(values)
        response = await isporuciPaketeQRApi(values)

        if (response.error === 0) {
          setFeedback({
            type: 'success',
            message: response.message || 'Paket je uspjesno isporucen.',
          })
          formik.setFieldValue('paket', '')
          formik.setFieldTouched('paket', false)
          setTimeout(() => {
            paketInputRef.current?.focus()
          }, 0)
        } else {
          setFeedback({
            type: 'danger',
            message: response.message || 'An unexpected error occurred.',
          })
        }
      } catch (error: any) {
        console.error('Error: ', error)
        setFeedback({
          type: 'danger',
          message: error?.response?.data?.message || error?.message || 'Doslo je do greske.',
        })
        setStatus(error)
      } finally {
        setLoading(false)
        setSubmitting(false)
      }
    },
  })

  return (
    <div className='container-fluid px-3 px-md-6 py-4 isporuci-paket-terminal'>
      <style>
        {`
          .isporuci-paket-terminal {
            max-width: 760px;
          }

          .isporuci-paket-terminal .scan-button-wrap .btn {
            min-height: 64px;
            border-radius: 8px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            font-size: 1.25rem;
          }

          .isporuci-paket-terminal .scan-button-wrap svg {
            width: 32px;
            height: 32px;
          }

          .isporuci-paket-terminal .terminal-input {
            min-height: 64px;
            font-size: 1.35rem;
          }

          .isporuci-paket-terminal .terminal-submit {
            min-height: 58px;
          }

          @media (max-width: 767.98px) {
            .isporuci-paket-terminal {
              padding-left: 10px !important;
              padding-right: 10px !important;
            }

            .isporuci-paket-terminal .card-body {
              padding: 16px !important;
            }

            .isporuci-paket-terminal .scan-button-wrap .btn,
            .isporuci-paket-terminal .terminal-input {
              min-height: 72px;
            }

            .isporuci-paket-terminal .terminal-input {
              font-size: 1.45rem;
            }

            .isporuci-paket-terminal .terminal-submit {
              min-height: 64px;
              font-size: 1.1rem;
            }
          }
        `}
      </style>

      <div className='card shadow-sm border-0'>
        <div className='card-header border-0 pt-6 pb-3'>
          <div className='card-title flex-column align-items-start m-0'>
            <div className='d-flex align-items-center gap-3'>
              <div className='symbol symbol-45px'>
                <div className='symbol-label bg-light-primary'>
                  <KTIcon iconName='delivery' className='fs-2 text-primary' />
                </div>
              </div>
              <div>
                <h1 className='fs-3 fw-bold text-gray-900 mb-1'>Isporuci paket</h1>
                <div className='text-muted fw-semibold fs-7'>
                  Kamera ili Zebra skener za isporuku paketa termopanela.
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id='kt_account_profile_details' className='collapse show'>
          <form onSubmit={formik.handleSubmit} onKeyDown={handleFormKeyDown} noValidate>
            <div className='card-body border-top p-9'>
              <div className='mb-6'>
                <div className='d-flex align-items-center justify-content-between gap-3 mb-3'>
                  <label className='form-label required fw-bold fs-6 mb-0'>Paket</label>
                  <span className='badge badge-light-primary fw-semibold'>Zebra spremno</span>
                </div>

                <div className='row g-3 align-items-end'>
                  <div className='col-12 col-sm-4 scan-button-wrap d-grid'>
                    <label className='form-label fw-semibold text-muted d-sm-none'>
                      Kamera skener
                    </label>
                    <QrCodeScanner onScan={handleQrScan} />
                  </div>

                  <div className='col-12 col-sm-8 fv-row'>
                    <label className='form-label fw-semibold text-muted d-none d-sm-block'>
                      Klikni polje i skeniraj uredajem
                    </label>
                    <input
                      ref={paketInputRef}
                      type='text'
                      inputMode='numeric'
                      autoComplete='off'
                      placeholder='Skenirajte ili unesite paket'
                      {...formik.getFieldProps('paket')}
                      onChange={(event) => {
                        setFeedback(null)
                        formik.handleChange(event)
                      }}
                      onFocus={(event) => event.currentTarget.select()}
                      className='form-control form-control-lg form-control-solid terminal-input fw-bold'
                    />
                  </div>
                </div>

                {formik.touched.paket && formik.errors.paket && (
                  <div className='text-danger fw-semibold mt-3'>Skenirajte paket.</div>
                )}

                <div className='text-muted fs-7 mt-3'>
                  Za Zebra skener dodirnite polje paketa, zatim skenirajte barkod ili QR kod.
                </div>

                {feedback && (
                  <div
                    className={`alert alert-${feedback.type} d-flex align-items-center mt-5 mb-0`}
                  >
                    <KTIcon
                      iconName={feedback.type === 'success' ? 'check-circle' : 'information-5'}
                      className='fs-2 me-3'
                    />
                    <div className='fw-semibold'>{feedback.message}</div>
                  </div>
                )}

                <div className='row mt-5'>
                  <div className='col-12 fv-row'>
                    <button
                      type='submit'
                      className='btn btn-primary w-100 terminal-submit fw-bold'
                      disabled={loading || formik.isSubmitting || !formik.isValid}
                    >
                      {!loading && (
                        <>
                          <KTIcon iconName='check-circle' className='fs-2 me-2' />
                          Potvrdi isporuku
                        </>
                      )}
                      {loading && (
                        <span className='indicator-progress' style={{display: 'block'}}>
                          Please wait...{' '}
                          <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                        </span>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default IsporuciPaket
